import React from 'react'

// Hooks
import useDataLayer from '../../../hooks/useDataLayer/dataLayerBody'

// Assets
import * as S from './style'

const Hero = () => {
  const [ sendDatalayerEvent ] = useDataLayer()

  return (
    <S.Section
      role='img'
      aria-label='jovem de cabelo liso, sorrindo e segurando um computador'
      className='py-5 d-flex align-items-md-center'
    >
      <div className='container d-flex align-items-end'>
        <div className='row'>
          <div className='col-12 col-md-5'>
            <h1 className='text-white fs-24 fs-md-28 fs-lg-32 fs-xl-48 lh-28 lh-md-33 lh-lg-38 lh-xl-55 fw-500'>
              <span className='d-lg-block'><span className='d-md-block'><span className='d-block d-md-inline'>Seu trabalho</span> pode</span> gerar mais impacto</span>
            </h1>
            <p className='text-white fs-14 fs-md-16 fs-xl-18 lh-16 lh-md-19 lh-xl-22 mt-lg-4'>
              Acreditamos que o seu trabalho pode criar um mundo com mais oportunidades. Esse é o jeito Inter de fazer: inovação, excelência e uma mentalidade construída para transformar vidas.
            </p>
            <p className='text-white fs-14 fs-md-16 fs-xl-18 lh-16 lh-md-19 lh-xl-22 mt-lg-4'>
              Se você quer fazer parte de algo maior e construir um legado, seu lugar é aqui.
            </p>
            <S.Btn
              onClick={() => {
                sendDatalayerEvent({
                  section: 'dobra_1',
                  element_action: 'click button',
                  element_name: 'Conferir vagas',
                  section_name: 'Seu trabalho pode gerar mais impacto',
                  redirect_url: 'carreiras',
                })
              }}
              to='carreiras'
              title='Veja nossas vagas disponíveis'
              className='fs-14 fw-600 text-none mb-0 mw-100 px-5 py-2 mt-2 mt-lg-4'
            >
              Conferir vagas
            </S.Btn>
          </div>
        </div>
      </div>
    </S.Section>
  )
}

export default Hero
